import React from 'react';
import graphql from "babel-plugin-relay/macro";
import {useMutation} from "react-relay";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import FormModal from "../../../components/common/modals/FormModal";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewPractitionerLocationPracticePeriodModal = ({showModal, onClose, practitionerLocationId}) => {
    const mutation = graphql`
    mutation NewPractitionerLocationPracticePeriodModalMutation($practitionerLocationId: ID!, 
        $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
      practitionerLocation {
          createPracticePeriod(input: {practitionerLocationId: $practitionerLocationId, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
              practitionerLocationPracticePeriod {
                  id
                  practitionerLocation {
                      practicePeriods {
                          ...PractitionerLocationPracticePeriods_PracticePeriod
                      }}}}}}`
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        practitionerLocationId: practitionerLocationId,
    }
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(bandedSchema)});
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.practitionerLocation) {
                    toast.success("Practice Period for Provider Location created")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New Practice Period"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
export default NewPractitionerLocationPracticePeriodModal
